import ApiError from "./ApiError";

export default class TooManyFailedLoginAttempts extends ApiError{
}